import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c34d8cc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full overflow-hidden" }
const _hoisted_2 = { class: "calculated-height" }
const _hoisted_3 = { class: "h-full flex" }
const _hoisted_4 = { class: "w-3/4 h-full" }
const _hoisted_5 = { class: "w-1/4 h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBar = _resolveComponent("AppBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "main", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "right", {}, undefined, true)
        ])
      ])
    ])
  ]))
}